import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { ImageGridComponent } from './image-grid.component';

export const Ng1ImageGridModule = angular.module('control-room.angular.image-grid', [])
  .directive('crImageGrid', downgradeComponent({ component: ImageGridComponent }) as angular.IDirectiveFactory);
